// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---gatsby-theme-cara-src-templates-cara-tsx": () => import("./../../../../gatsby-theme-cara/src/templates/cara.tsx" /* webpackChunkName: "component---gatsby-theme-cara-src-templates-cara-tsx" */)
}

